import { render, staticRenderFns } from "./BtnShare.vue?vue&type=template&id=05e40b17&"
import script from "./BtnShare.vue?vue&type=script&lang=js&"
export * from "./BtnShare.vue?vue&type=script&lang=js&"
import style0 from "./BtnShare.vue?vue&type=style&index=0&id=05e40b17&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BtnShare.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports